import { Navigate, Outlet } from 'react-router'
import { hasToken } from '../lib/auth.ts'

/** Route guard: bounce to /login if no token. */
export function RequireAuth() {
  if (!hasToken()) return <Navigate to="/login" replace />
  return <Outlet />
}
